import Component from "@glimmer/component";
import { service } from "@ember/service";
import { task } from "ember-concurrency";
import { action } from "@ember/object";

export default class ModalsDnsRegisterDomainDetails extends Component {
  @service modal;

  get task() {
    return this.args.params.task;
  }

  get organization() {
    return this.args.params.organization;
  }

  get countries() {
    return this.args.params.countries;
  }

  get domains() {
    return this.args.params.domains;
  }

  organizationIdentityNumber = this.organization.identityNumber;
  organizationName = this.organization.name;
  organizationFirstname;
  organizationLastname;
  organizationAddress = this.organization.address;
  organizationZip = this.organization.zip;
  organizationCity = this.organization.city;
  organizationEmail = this.organization.email;
  organizationPhone = this.organization.phone;

  organizationCountry = this.countries.find(
    (country) => country.name.toLowerCase() === this.organization.country.toLowerCase(),
  )?.code;

  submitTask = task(async () => {
    let task = this.task;
    let data = {
      organization: this.organizationName,
      organizationnumber: this.organizationIdentityNumber,
      firstname: this.organizationFirstname,
      lastname: this.organizationLastname,
      address: this.organizationAddress,
      zipcode: this.organizationZip,
      city: this.organizationCity,
      country: this.organizationCountry,
      email: this.organizationEmail,
      phonenumber: this.organizationPhone,
    };

    await task.perform(data);
    this.modal.close();
  });

  @action
  onFormChange({
    organizationName,
    organizationIdentityNumber,
    organizationFirstname,
    organizationLastname,
    organizationAddress,
    organizationCity,
    organizationZip,
    organizationCountry,
    organizationEmail,
    organizationPhone,
  }) {
    this.organizationName = organizationName;
    this.organizationIdentityNumber = organizationIdentityNumber;
    this.organizationFirstname = organizationFirstname;
    this.organizationLastname = organizationLastname;
    this.organizationAddress = organizationAddress;
    this.organizationCity = organizationCity;
    this.organizationZip = organizationZip;
    this.organizationCountry = organizationCountry;
    this.organizationEmail = organizationEmail;
    this.organizationPhone = organizationPhone;
  }
}
